<template>
	<a-modal
		title="下分"
		:width="520"
		:visible="visible"
		:confirmLoading="loading"
		:maskClosable="false"
		:forceRender="true"
		@ok="handleOk"
		@cancel="() => { $emit('cancel') }"
	>
		<a-form-model ref="form" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 15 }">
			<a-form-model-item label="用户">
				<span>{{ userLabel }}</span>
			</a-form-model-item>
			<a-form-model-item label="当前余额">
				<span>{{ balanceText }}</span>
			</a-form-model-item>
			<a-form-model-item label="下分金额" prop="cashOutAmount" :rules="amountRules">
				<a-input-number
					v-model="form.cashOutAmount"
					:min="0.01"
					:max="maxAmount"
					:step="1"
					:precision="2"
					style="width: 100%"
					placeholder="扣减余额金额"
				/>
			</a-form-model-item>
		</a-form-model>
	</a-modal>
</template>

<script>
import { fmtMoney } from '@/utils/money';

const amountRules = [
	{ required: true, type: 'number', message: '必填，不能为空', trigger: 'change' },
];

function emptyForm() {
	return {
		cashOutAmount: undefined,
	};
}

export default {
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		user: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			form: emptyForm(),
			amountRules,
		};
	},
	computed: {
		userLabel() {
			if (!this.user) {
				return '-';
			}
			const name = this.user.nickname || this.user.loginAccount || this.user.id;
			return `${name}（ID:${this.user.id}）`;
		},
		balanceText() {
			if (!this.user) {
				return '-';
			}
			return fmtMoney(this.user.balance);
		},
		maxAmount() {
			const balance = Number(this.user && this.user.balance);
			if (Number.isNaN(balance) || balance <= 0) {
				return 0.01;
			}
			return balance;
		},
	},
	watch: {
		visible(val) {
			if (val) {
				this.form = emptyForm();
				this.$nextTick(() => {
					if (this.$refs.form) {
						this.$refs.form.clearValidate();
					}
				});
			}
		},
	},
	methods: {
		handleOk() {
			if (!this.$refs.form || !this.user) {
				return;
			}
			this.$refs.form.validate((valid) => {
				if (!valid) {
					return;
				}
				this.$emit('ok', {
					userId: this.user.id,
					cashOutAmount: this.form.cashOutAmount,
				});
			});
		},
	},
};
</script>
